module.exports = __webpack_public_path__ + "static/media/4.87d65d04.jpg";